import type { OnInit } from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  Renderer2,
  inject,
} from '@angular/core';
import { CookieService } from 'ngx-cookie';

@Component({
  standalone: false,
  selector: 'fl-synthetic-performance-tracking',
  template: ` <ng-container /> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SyntheticPerformanceTrackingComponent implements OnInit {
  private cookies = inject(CookieService);
  private renderer = inject(Renderer2);

  ngOnInit(): void {
    /**
     * Adds a 'sc-no-animation' class on the root element ('html') when a
     * 'no_animation' cookie is present. This can then be used to disable CSS
     * animations / transitions as they don't play nice with synthetics monitoring
     * & visual completness score (a.k.a. Speed Index).
     */
    if (this.cookies.get('no_animation')) {
      this.renderer.addClass(document.documentElement, 'sc-no-animation');
    }
  }
}
